import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/playPlanPublish',
  title: window.language['menu.playPlan.planPublish'],
  component: dynamicWrapper(app, [
    import('./model'),
    import('../../Material/Material/model'),
    import('../../HomePage/model'),
  ], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Program/PlayPlanPublish/index.js